<div class="position-relative h-100">
	<img src="./assets/media/TILES-BG.png" width="100%" class="object-fit-bg bg-home-bertazzoni" />
	<div class="opaque-layer position-absolute pt-5">
		<div class="container px-lg-0">
			<div class="row">
				<div class="col-xs-12 col-md-4 offset-md-4 text-white my-4 text-center">
					<div class="login">
						<form #form="ngForm">
							<input
								type="text"
								class="form-control form-bertazzoni rounded-0 bg-black font-12 my-2"
								placeholder="USERNAME"
								[(ngModel)]="username"
								name="username"
								required
								autofocus />
							<input
								type="password"
								class="form-control form-bertazzoni rounded-0 bg-black font-12 my-2"
								placeholder="PASSWORD"
								[(ngModel)]="password"
								name="password"
								required />
							<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="login()" [disabled]="form.invalid">LOGIN</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
